import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { List } from "../primitives/list";
import { Color3GradientComponent, Color4GradientComponent, FactorGradientComponent } from "../primitives/gradient";
import { Color3Gradient, ColorGradient as Color4Gradient, FactorGradient } from "core/Misc/gradients";
import { Color3, Color4 } from "core/Maths/math.color";
// Convert gradients to LineList items and sort by gradient value
function GradientsToListItems(gradients) {
    return (gradients?.map((gradient, index) => ({
        id: index,
        data: gradient,
        sortBy: gradient.gradient,
    })) ?? []);
}
export const FactorGradientList = (props) => {
    FactorGradientList.displayName = "FactorGradientList";
    const { gradients } = props;
    const items = useMemo(() => GradientsToListItems(gradients), [gradients]);
    return (_jsx(List, { addButtonLabel: items.length > 0 ? `Add new ${props.label}` : `Use ${props.label}s`, items: items, onDelete: (item, index) => props.removeGradient(item.data, index), onAdd: () => {
            if (items.length === 0) {
                props.addGradient(); // Default
            }
            else {
                props.addGradient(new FactorGradient(1, 1, 1));
            }
        }, renderItem: (item, index) => {
            return (_jsx(FactorGradientComponent, { value: item.data, onChange: (newGradient) => {
                    item.data.gradient = newGradient.gradient;
                    item.data.factor1 = newGradient.factor1;
                    item.data.factor2 = newGradient.factor2;
                    props.onChange(newGradient, index);
                } }));
        } }, "Factor"));
};
export const Color3GradientList = (props) => {
    Color3GradientList.displayName = "Color3GradientList";
    const { gradients } = props;
    const items = useMemo(() => GradientsToListItems(gradients), [gradients]);
    return (_jsx(List, { addButtonLabel: items.length > 0 ? `Add new ${props.label}` : `Use ${props.label}s`, items: items, onDelete: (item, index) => props.removeGradient(item.data, index), onAdd: () => {
            if (items.length === 0) {
                props.addGradient(); // Default
            }
            else {
                props.addGradient(new Color3Gradient(1, Color3.White()));
            }
        }, renderItem: (item, index) => {
            return (_jsx(Color3GradientComponent, { value: item.data, onChange: (newGradient) => {
                    item.data.gradient = newGradient.gradient;
                    item.data.color = newGradient.color;
                    props.onChange(newGradient, index);
                } }));
        } }, "Color3"));
};
export const Color4GradientList = (props) => {
    Color4GradientList.displayName = "Color4GradientList";
    const { gradients } = props;
    const items = useMemo(() => GradientsToListItems(gradients), [gradients]);
    return (_jsx(List, { addButtonLabel: items.length > 0 ? `Add new ${props.label}` : `Use ${props.label}s`, items: items, onDelete: (item, index) => props.removeGradient(item.data, index), onAdd: () => {
            if (items.length === 0) {
                props.addGradient(); // Default
            }
            else {
                props.addGradient(new Color4Gradient(1, new Color4(1, 1, 1, 1), new Color4(1, 1, 1, 1)));
            }
        }, renderItem: (item, index) => {
            return (_jsx(Color4GradientComponent, { value: item.data, onChange: (newGradient) => {
                    item.data.gradient = newGradient.gradient;
                    item.data.color1 = newGradient.color1;
                    item.data.color2 = newGradient.color2;
                    props.onChange(newGradient, index);
                } }));
        } }, "Color4"));
};
//# sourceMappingURL=gradientList.js.map